<template>
  <div class="containerBox" id="app">
    <div class="topNav">
      <div class="name">{{ userData.name }}</div>
      <at-menu mode="horizontal" active-name="3-2" class="navBox">
        <at-menu-item name="1"><i class="icon icon-home"></i>首页</at-menu-item>
        <at-submenu>
          <template slot="title"><i class="icon icon-layers"></i>餐桌</template>
          <at-menu-item name="3-1"><i class="icon icon-settings"></i></at-menu-item>
        </at-submenu>
        <at-submenu>
          <template slot="title"><i class="icon icon-life-buoy"></i>采购</template>
          <at-menu-item name="3-1"><i class="icon icon-settings"></i></at-menu-item>
        </at-submenu>
        <at-submenu>
          <template slot="title"><i class="icon icon-grid"></i>菜单</template>
          <at-menu-item name="3-1"><i class="icon icon-settings"></i></at-menu-item>
        </at-submenu>
        <at-submenu>
          <template slot="title"><i class="icon icon-user"></i>员工</template>
          <at-menu-item name="3-1"><i class="icon icon-settings"></i></at-menu-item>
        </at-submenu>
        <at-submenu>
          <template slot="title"><i class="icon icon-user"></i>会员</template>
          <at-menu-item name="3-1"><i class="icon icon-settings"></i></at-menu-item>
        </at-submenu>
        <at-submenu>
          <template slot="title"><i class="icon icon-list"></i>流水</template>
          <at-menu-item name="3-1"><i class="icon icon-bar-chart"></i>流水统计</at-menu-item>
          <at-menu-item name="3-2"><i class="icon icon-menu"></i>流水详情</at-menu-item>
        </at-submenu>
        <at-submenu>
          <template slot="title"><i class="icon icon-bar-chart-2"></i>统计</template>
          <at-menu-item name="3-1"><i class="icon icon-settings"></i></at-menu-item>
        </at-submenu>
        <at-submenu>
          <template slot="title"><i class="icon icon-settings"></i>设置</template>
          <at-menu-item name="3-1"><i class="icon icon-settings"></i></at-menu-item>
        </at-submenu>
      </at-menu>
      <div @click="back" class="userBox">
        <span>餐厅经理</span>
        <i class="icon icon-align-justify"></i>
      </div>
    </div>
    <div class="wrapBox">
      <at-breadcrumb>
        <at-breadcrumb-item>流水</at-breadcrumb-item>
        <at-breadcrumb-item>流水详情</at-breadcrumb-item>
      </at-breadcrumb>
      <div class="conBox">
        <div class="totalBox">
          <at-card>
            <h4 slot="title">流水总金额：{{ totalInfo.mustPay }}元</h4>
          </at-card>
          <at-card>
            <h4 slot="title">流水总数量：{{ totalInfo.totalOrder }}笔</h4>
          </at-card>
        </div>
        <div class="queryBox">
          <at-input v-model.trim="queryParams.deskCode" placeholder="输入关键字"></at-input>
          <div class="dateBox">
            <at-input v-model.trim="queryParams.nian1" placeholder="输入年"></at-input>年
            <at-input v-model.trim="queryParams.yue1" placeholder="输入月"></at-input>月
            <at-input v-model.trim="queryParams.ri1" placeholder="输入日"></at-input>日
            ~
            <at-input v-model.trim="queryParams.nian2" placeholder="输入年"></at-input>年
            <at-input v-model.trim="queryParams.yue2" placeholder="输入月"></at-input>月
            <at-input v-model.trim="queryParams.ri2" placeholder="输入日"></at-input>日
          </div>
          <at-button type="primary" @click="handleQuery()" style="margin-left: 10px">搜索</at-button>
          <at-button  @click="reset()" style="margin-left: 10px">清空</at-button>
        </div>
        <at-table :columns="columns" :data="list" stripe style="margin-top: 14px"></at-table>
        <at-pagination :total="total" @page-change="onChange" @pagesize-change="onSizeChange" show-sizer style="margin: 10px 0 0 0;"></at-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
      return {
        userData: {},
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          deskCode: undefined,
          orderCode: undefined,
          status: undefined,
          nian1: '',
          yue1: '',
          ri1: '',
          nian2: '',
          yue2: '',
          ri2: ''
        },
        // 表单参数
        form: {},
        totalInfo: {
            mustPay: 0,
            totalOrder: 0
        },
        dateRange: null,
        total: 0,
        list: [],
        columns: [
          {
              title: '序列',
              key: 'index',
              width: 70,
              align: 'center'
          },
          {
              title: '流水号',
              key: 'orderCode',
              align: 'center'
          },
          {
              title: '金额',
              key: 'totalPrice',
              align: 'center'
          },
          {
              title: '餐桌号',
              key: 'deskCode',
              align: 'center'
          },
          {
              title: '客户数量',
              key: 'peopleNum',
              align: 'center'
          },
          {
              title: '会员姓名',
              key: 'kefu',
              align: 'center'
          },
          {
              title: '员工姓名',
              key: 'yuangong',
              align: 'center'
          },
          {
              title: '就餐时间',
              key: 'createTime',
              align: 'center'
          },
          {
              title: '操作',
              render: (h, params) => {
              return h('div', [
                h('AtButton', {
                  props: {
                    size: 'small',
                    hollow: true
                  },
                  style: {
                    marginRight: '8px'
                  },
                  on: {
                    click: () => {
                    }
                  }
                }, '详情'),
                h('AtButton', {
                  props: {
                    size: 'small',
                    hollow: true,
                    type: 'error'
                  },
                  on: {
                    click: () => {
                    }
                  }
                }, '删除')
              ])
            }
          }
      ],
      }
  },
  mounted() {
      window.addEventListener('message', e => {
        if (e.data.msgType == 'userInfo') {
            this.userData = e.data.info
        } else if (e.data.msgType == 'totalInfo') {
          this.totalInfo = e.data.data
        } else if (e.data.msgType == 'listInfo') {
          this.list = e.data.data.list.map((item, index) => {
            return {
              ...item,
              peopleNum: `${item.peopleNum}人`,
              kefu: '-',
              yuangong: '-',
              index: +index+1,
              deskCode: `${item.deskCode}号`,
              orderCode: this.countOrderCode(item.orderCode)
            }
          })
          this.total = e.data.data.total
        }
      })
  },
  methods: {
    countOrderCode(val) {
        const arr = val ? val.split('-') : []
        return `${arr[0] || 0}${arr[1] || 0}·${arr[2] || 0}`
    },
    back() {
        window.parent.postMessage({
          type: 'LogOut'
        }, "*");
    },
    onChange(val) {
      this.queryParams.pageNum = val
      this.getList()
    },
    onSizeChange(val) {
      this.queryParams.pageSize = val
      if (this.queryParams.pageNum == 1) {
          this.getList()
      }
    },
      /** 查询岗位列表 */
    getList() {
      const params = {
        ...this.queryParams
      }
      let arr = []
      const { nian1, nian2, yue1, yue2, ri1, ri2 } = this.queryParams
      if (!this.isNullOrEmpty(nian1) || !this.isNullOrEmpty(nian2) || !this.isNullOrEmpty(yue1) || !this.isNullOrEmpty(yue2) || !this.isNullOrEmpty(ri1) || !this.isNullOrEmpty(ri2)) {
        if (this.isNullOrEmpty(nian1) || this.isNullOrEmpty(nian2) || this.isNullOrEmpty(yue1) || this.isNullOrEmpty(yue2) || this.isNullOrEmpty(ri1) || this.isNullOrEmpty(ri2)) {
          this.$Message.warning('请输入完整的时间信息')
          return
        } else {
          arr = [`${nian1}-${yue1}-${ri1} 00:00:00`, `${nian2}-${yue2}-${ri2} 23:59:59`]
        }
      }
      if (arr[0]) {
        params.startTime = arr[0]
      }
      if (arr[1]) {
        params.endTime = arr[1]
      }
      window.parent.postMessage({
          type: "getList",
          data: Object.keys(params).reduce((obj, item) => {
            if (params[item]) {
              obj[item] = params[item]
            }
            return obj
          }, {})
      }, "*");
    },
    reset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        deskCode: undefined,
        orderCode: undefined,
        status: undefined,
        nian1: '',
        yue1: '',
        ri1: '',
        nian2: '',
        yue2: '',
        ri2: ''
      }
      this.handleQuery()
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      const params = {
        ...this.queryParams
      }
      let arr = []

      if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
        arr = [`${this.dateRange[0]} 00:00:00`, `${this.dateRange[1]} 23:59:59`]
      }
      if (arr[0]) {
        params.startTime = arr[0]
      }
      if (arr[1]) {
        params.endTime = arr[1]
      }
      window.parent.postMessage({
        type: "getTotal",
        data: {
            ...params
        }
      }, "*");
      this.getList()
    },
    isNullOrEmpty(obj) {
      const result = (obj === null || obj === 'null' || obj === undefined || obj === 'undefined' || typeof obj === 'undefined' || obj === '' || JSON.stringify(obj) === '{}' || JSON.stringify(obj) === '[]' || obj === '[]')
      if (result && (obj !== 0 || obj !== '0')) {
        return result
      }
      return false
    }
  },
  beforeDestroy() {
      window.removeEventListener('message')
  },
}
</script>

<style scoped>
.queryBox{
  display: flex;
  align-items: center;
  margin-top: 14px;
}
  .containerBox {
    width: 100%;
    height: 100%;
    display: flex;
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    color: #2c3e50;
    text-align: center;
    background: #f5f7f9;
  }
  .topNav{
    display: flex;
    align-items: center;
    background: #fff;
    height: 64px;
    box-sizing: border-box;
    padding: 0 20px 0 40px;
    border-bottom: 1px solid #e2ecf4;
  }
  .at-menu{
    height: 65px;
    line-height: 65px;
  }
  .name{
    color: #2c3e50;
    font-weight: bold;
    font-size: 24px;
    font-style: italic;
  }
  .navBox{
    margin-left: auto;
  }
  .userBox{
    color: #2c3e50;
    margin-left: 10px;
    border-left: 1px solid #a1a3a5;
    padding-left: 10px;
    height: 15px;
    line-height: 15px;
  }
  .wrapBox{
    padding: 20px 50px;
    text-align: left;
    flex: 1;
  }
  .conBox{
    background: #fff;
    padding: 20px;
    margin-top: 20px;
  }
  .totalBox{
    display: flex;
    justify-content: space-around;
  }
  .totalBox .at-card{
    box-shadow: 1px 0 16px 0 rgba(100, 100, 100, 0.2);
    width: 300px;
    height: 48px;
    border-bottom: none;
    overflow: hidden;
  }
  .dateBox{
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  .dateBox .at-input{
    width: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue